import $ from 'jquery';
import localize from './localize';

let collapse = {

  triggersSelector: '.js-collapse-trigger:not(.js-collapse-trigger-initialized)',
  $triggers: undefined,

  setMaxHeight: function ($target) {
    let targetHeight = $target.find('> *').outerHeight(true);
    if (targetHeight > 0) {
      $target.css({
        'max-height': targetHeight
      });
    }
  },

  /**
   * @returns {void}
   */
  initialize: function () {

    collapse.$triggers = $(collapse.triggersSelector);
    if (collapse.$triggers.length === 0) {
      return;
    }

    const $filterAccordion = $('.js-filter-accordion');
    if ($filterAccordion.length > 0) {
      $('.js-search-result-count').append(`<button class="c-button c-button--style-text c-button--size-small js-search-filter-button"></button>`);
    }

    const $searchFilterButton = $('.js-search-filter-button');
    const filterAccordionIsExpanded = () => $filterAccordion.attr('data-collapse-item') === 'expanded';

    if (filterAccordionIsExpanded()) {
      $searchFilterButton.hide();
    }

    $searchFilterButton.text(' ' + localize('search.filter'));

    $searchFilterButton.click(function () {
      if (!filterAccordionIsExpanded()) {
        $filterAccordion.find('.js-collapse-trigger').click();
      }
      $filterAccordion[0].scrollIntoView();
      $filterAccordion.find('[data-collapse-item]').focus();
    });

    collapse.$triggers.each(function () {
      let $trigger = $(this);
      let $item = $trigger.closest('.js-collapse-item');
      let $target = $item.find('[data-collapse-target]').first();

      $target.tabIndex = -1;
      if ($item.attr('data-collapse-item') !== 'expanded') {
        $target.attr('inert', 'true');
      }

      $trigger.on('click', function (event) {
        event.preventDefault();

        if ($item.attr('data-collapse-item') === 'expanded') {
          $trigger.attr('aria-expanded', 'false');
          $item.attr('data-collapse-item', '');
          $target.attr('inert', 'true');

          if ($item.hasClass('js-filter-accordion')) {
            $searchFilterButton.show();
          }

          setTimeout(function () {
            $target.removeAttr('style');
          }, parseInt($target.css('transition-duration'), 10));
        } else {
          collapse.setMaxHeight($target);

          $trigger.attr('aria-expanded', 'true');
          $item.attr('data-collapse-item', 'expanded');
          $target.removeAttr('inert');

          if ($item.hasClass('js-filter-accordion')) {
            $searchFilterButton.hide();
          }
        }
      });
    });

    $('[data-collapse-item="expanded"] [data-collapse-target]').each(function () {
      collapse.setMaxHeight($(this));
    });

    collapse.$triggers.addClass('js-collapse-trigger-initialized');
  }
};

$(window).on('refresh', function () {
  collapse.initialize();
});
collapse.initialize();
